export default __webpack_public_path__ + "5b2abe1e579c068b106844bbab9a22fb.png";